import { IconFont } from '@byecode/ui'
import type { ValueVariable } from '@lighthouse/core'
import { getColorById, getImageFullUrlInApplication, useApplicationContext } from '@lighthouse/shared'
import { find } from 'rambda'
import React, { useMemo } from 'react'
import styled from 'styled-components'

import { useCurrentAppId } from '@/hooks/useApplication'

import * as SC from './styles'

const PersonName = styled.span`
    font-size: var(--font-size-normal);
    color: var(--color-black);
    white-space: nowrap;
`

const SCxPersonAvatar = styled.img`
    display: flex;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    min-width: 22px;
    border-radius: 50%;
    margin-right: 4px;
    display: block;
`

const SCxPersonTextAvatar = styled.div<{ background?: string }>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 22px;
    min-width: 22px;
    height: 22px;
    line-height: 22px;
    font-size: var(--font-size-sm);
    margin-right: 4px;
    border-radius: 50%;
    color: var(--color-white);
    background-color: ${({ background }) => background || 'var(--color-gray-2)'};
`

interface PersonTagProps {
    data: ValueVariable
    withClose?: boolean
    onClose?: () => void
}

export const PersonTag: React.FC<PersonTagProps> = ({ data, withClose = true, onClose }) => {
    const { personOptions } = useApplicationContext()
    const appId = useCurrentAppId()
    const valueUserId = data.valueVariable?.value && Array.isArray(data.valueVariable?.value) ? data.valueVariable?.value?.[0] : ''
    const person = find(item => item.id === valueUserId, personOptions || [])
    const avatarContent = useMemo(() => {
        if (valueUserId === '{currentUserId}') {
            return (
                <SC.IconWrapper>
                    <IconFont size={16} type="UserCircle" fill="var(--color-gray-400)" />
                </SC.IconWrapper>
            )
        }
        if (!person) {
            return null
        }
        const { avatar, name, id } = person

        const background = getColorById(id)
        if (avatar) {
            return <SCxPersonAvatar src={getImageFullUrlInApplication(appId, avatar)} />
        }
        return <SCxPersonTextAvatar background={background}>{name.charAt(0)}</SCxPersonTextAvatar>
    }, [appId, person, valueUserId])

    const username = useMemo(() => {
        if (valueUserId === '{currentUserId}') {
            return '当前用户'
        }
        return person?.name
    }, [person?.name, valueUserId])

    return (
        <SC.Node>
            {avatarContent}
            <PersonName>{username}</PersonName>
            {withClose && <SC.Close type="Close" fill="var(--color-gray-600)" onClick={onClose} />}
        </SC.Node>
    )
}
